import { makeStyles } from '@mui/styles';

export const useSmallSelectStyles = makeStyles(() => ({
  root: {
    padding: '5px 15px',
    textTransform: 'uppercase',
    fontSize: '0.8125rem',
    fontWeight: 500,

    '&:focus': {
      background: 'transparent',
      borderRadius: 4,
    },
  },
  icon: {
    top: 2,
  },
}));
